<div class="avatar-container">
  <kh-webgl-unsupported *ngIf="!webGLSupported"></kh-webgl-unsupported>
  <ng-container *ngIf="webGLSupported">
    <div #spineContainer class="spine-container d-flex align-items-center"></div>
    <div class="loader" *ngIf="loading"></div>
  </ng-container>
</div>
